import * as React from "react"
import { Box } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"

import { monitoringAdminReportFilters } from "../../@signals";


export default function optionsColumn() {
    return {
        name: '', label: 'Options',
        options: {
            filter: false,
            setCellProps: () => ({ sx: { textAlign: "center", maxWidth: 50 } }),
            customBodyRowRenderLite: (value, row) => <Box sx={{ display: 'flex', justifyContent: 'center' }} >
                <ButtonIconSeeker
                    icon="pen"
                    tooltip="Update Report"
                    onClick={() => monitoringAdminReportFilters.value = row}
                />
            </Box>
        }
    }
}
